
export class Pricing {
    id: number;
    name: string;
    nameFr: string;
    nicename: string;
    description: string;
}
